import { PARAMETRE } from "app/main/ged/parametre/parametre.state";

export const locale = {
    lang: 'fr',
    data: {
        PARAMETERS: {
            SEARCH: 'Rechercher des paramètres',
            SEARCH_TEXT: 'Rechercher...',
            NO_RESULTS: 'Aucun résultat trouvé',
            PARAMETRE: 'Paramètre',
        }
    }
};